import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { useAdminApplication, useAdminSession } from "../../app/providers";
import { ServiceStatusView } from "./components/ServiceStatusView";
import { getServiceHistory, refreshServiceWork } from "./service-status-api";
import { currentSeoulDate, parseDashboardDate } from "./schema";

export function DashboardPage() {
  const { apiClient } = useAdminApplication();
  const session = useAdminSession();
  const [params, setParams] = useSearchParams();
  const today = currentSeoulDate();
  const latestDate = new Date(Date.parse(`${today}T00:00:00Z`) - 86400000).toISOString().slice(0, 10);
  const rawDate = params.get("date");
  const parsed = parseDashboardDate(rawDate);
  const selectedDate = parsed && parsed <= latestDate ? parsed : latestDate;
  useEffect(() => {
    if (rawDate !== selectedDate) setParams({ date: selectedDate }, { replace: true });
  }, [rawDate, selectedDate, setParams]);
  const history = useQuery({
    queryKey: ["admin", session.sessionEpoch, "service-history", selectedDate],
    queryFn: ({ signal }) => getServiceHistory(apiClient, selectedDate, signal),
    retry: false,
  });
  const live = useQuery({
    queryKey: ["admin", session.sessionEpoch, "service-live"],
    queryFn: ({ signal }) => refreshServiceWork(apiClient, signal),
    refetchOnWindowFocus: false, retry: false, staleTime: 0,
  });
  return <ServiceStatusView
    selectedDate={selectedDate} latestDate={latestDate} history={history.data} live={live.data}
    historyLoading={history.isFetching} liveLoading={live.isFetching}
    historyError={history.isError ? "연결과 조회 권한을 확인한 뒤 다시 조회해 주세요." : undefined}
    liveError={live.isError ? "연결과 조회 권한을 확인한 뒤 새로고침해 주세요." : undefined}
    onQuery={(date) => { if (date === selectedDate) void history.refetch(); else setParams({ date }); }}
    onRefresh={() => { void live.refetch(); }}
  />;
}
